import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

import "../reportStyles.scss";
import { errorNormalizer } from "../../../shared/Helpers/functions";
import { CustomButton } from "../../../shared/uiComponents";
import { downloadFile, ReportFilters } from "../helpers";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { getUtilizationReport } from "../../../redux/State/clientSlice/insuranceAuthorizationSlice";

const UtilizationReport = () => {
  const dispatch = useDispatch<DispatchProperties>();

  const filterData = useSelector((state) => state.billing.billingFilters);
  const loading = useSelector((state) => state.authorization.loading);

  const downloadHandler = useCallback(() => {
    const { startDate, endDate, clientIds } = filterData;

    dispatch(
      getUtilizationReport({
        clientIds,
        startDate,
        endDate,
      })
    )
      .then(unwrapResult)
      .then((response) => downloadFile(response))
      .catch(errorNormalizer);
  }, [dispatch, filterData]);

  return (
    <>
      <ReportFilters showUsers={false} showOnlyNew={false} isMultipleSelect={true} />
      <div style={{ width: "max-content" }}>
        <CustomButton
          title="Download"
          onClick={downloadHandler}
          loading={loading}
          disabled={filterData.timeError}
        />
      </div>
    </>
  );
};

export default UtilizationReport;
